export default __webpack_public_path__ + "static/media/MetaMask.8bcca7d8.svg";